<div class="mb-3">
  <label *ngIf="label" class="form-label">
    {{ label }}
    <span *ngIf="required" class="text-danger ms-1">*</span>
  </label>

  <!-- Input nativo oculto (multiple) -->
  <input
    #fileInput
    type="file"
    class="d-none"
    [accept]="accept"
    [disabled]="isDisabled"
    multiple
    (change)="onFilesSelected($event)"
  >

  <!-- Dropzone -->
  <div
    *ngIf="!isMaxReached"
    class="is-multi-file__dropzone rounded-3 border border-2 text-center p-4"
    [class.is-multi-file__dropzone--active]="isDragging"
    [class.is-multi-file__dropzone--error]="hasError"
    [class.opacity-50]="isDisabled"
    role="button"
    tabindex="0"
    (click)="openFilePicker()"
    (keydown.enter)="openFilePicker()"
    (keydown.space)="openFilePicker()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <div class="mb-2" style="font-size: 2rem; color: #6c757d;">
      <i class="bx bx-cloud-upload"></i>
    </div>
    <p class="mb-1 fw-medium small text-dark">
      {{ 'IS_LIB.MULTI_FILE_DROP_TEXT' | translate }} <span class="text-primary">{{ 'IS_LIB.MULTI_FILE_DROP_CLICK' | translate }}</span>
    </p>
    <p class="mb-0 text-muted" style="font-size: 0.75rem;">
      <span *ngIf="acceptedFormatsLabel">{{ 'IS_LIB.FILE_FORMATS' | translate }}: {{ acceptedFormatsLabel }} · </span>
      {{ 'IS_LIB.FILE_MAX_SIZE' | translate }} {{ maxFiles }} ({{ maxSizeMb }}MB)
    </p>
  </div>

  <!-- Limite atingido -->
  <div *ngIf="isMaxReached" class="alert alert-info small py-2 mb-0">
    <i class="bx bx-info-circle me-1"></i>
    {{ 'IS_LIB.MULTI_FILE_LIMIT' | translate:{ maxFiles: maxFiles } }}
  </div>

  <!-- Lista de arquivos -->
  <div *ngIf="files.length > 0" class="mt-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="small text-muted fw-medium">
        {{ files.length }} {{ 'IS_LIB.MULTI_FILE_SELECTED' | translate }}
      </span>
      <button
        *ngIf="files.length > 1"
        type="button"
        class="btn btn-sm btn-link text-danger text-decoration-none p-0"
        (click)="clearAll()"
      >
        <i class="bx bx-trash me-1"></i>{{ 'IS_LIB.MULTI_FILE_REMOVE_ALL' | translate }}
      </button>
    </div>

    <ul class="list-group list-group-flush">
      <li
        *ngFor="let item of files; let i = index"
        class="list-group-item d-flex align-items-center px-3 py-2"
      >
        <i [class]="'bx ' + item.icon + ' me-3 text-primary'" style="font-size: 1.4rem;"></i>
        <div class="flex-grow-1 overflow-hidden">
          <p class="mb-0 small fw-medium text-truncate">{{ item.name }}</p>
          <p class="mb-0 text-muted" style="font-size: 0.7rem;">{{ item.size }}</p>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-outline-danger rounded-circle is-multi-file__remove ms-2"
          (click)="removeFile(i)"
          [attr.aria-label]="'IS_LIB.FILE_REMOVE' | translate"
        >
          <i class="bx bx-x"></i>
        </button>
      </li>
    </ul>
  </div>

  <!-- Help text -->
  <small *ngIf="helpText && !hasError && files.length === 0" class="form-text text-muted d-block mt-1">
    {{ helpText }}
  </small>

  <!-- Validation error -->
  <is-form-error *ngIf="control" [control]="control"></is-form-error>
</div>
